export default "__VITE_ASSET__BQnT9Jqo__"